import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CookiebotScriptComponent } from './cookiebot-script.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { catchError, EMPTY } from 'rxjs';
import { captureException } from '@portal-front/shared-util-sentry';

@UntilDestroy()
@Component({
  standalone: true,
  imports: [RouterModule, TranslateModule, CookiebotScriptComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'login-app',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Zaloguj się';

  private readonly gtmService = inject(GoogleTagManagerService);
  private readonly titleService = inject(Title);

  constructor(private translate: TranslateService) {}

  public ngOnInit(): void {
    this.initializePageTitle();
    // GTM may fail to load (ad blocker, network issue) – not critical for app functionality.
    this.gtmService.addGtmToDom().catch(() => {
      /* noop */
    });
  }

  private initializePageTitle(): void {
    this.translate
      .get('page-title')
      .pipe(
        catchError((error) => {
          captureException(error, { data: { context: 'initializePageTitle' } });
          return EMPTY;
        }),
        untilDestroyed(this),
      )
      .subscribe((title: string) => {
        this.titleService.setTitle(title);
      });
  }
}
